export const actionButtonClasses = {
  fixedInMobile: 'action-buttons-fixed-mobile',
  bordered: 'action-buttons-bordered',
  topBordered: 'action-buttons-top-bordered',
}
